import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=4b35c378&"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports